import "./style.scss";
import { useDispatch } from "react-redux"
import { incrementByAmount } from "../../store/Header";
import { useEffect } from "react";
import { Button, Form, Input, message, Modal, Image } from 'antd';
import { useState } from "react";
import { getContactList, subFrom } from "../../api";
import ChatCom from "../../components/ChatCom";
import { companyList } from "./config.js";
const AboutUsPage = () => {
    const dispatch = useDispatch();
    const [messageApi, contextHolder] = message.useMessage();
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isImg, setImg] = useState([]);
    useEffect(() => {
        dispatch(incrementByAmount(6));
    }, []);
    const layout = {
        labelCol: {
            span: 8,
        },
        wrapperCol: {
            span: 16,
        },
    };
    const validateMessages = {
        required: '${label} is required!',
        types: {
            email: '${label} is not a valid email!',
            number: '${label} is not a valid number!',
        },
        number: {
            range: '${label} must be between ${min} and ${max}',
        },
    };
    const success = (data) => {
        messageApi.open({
            type: 'success',
            content: data,
            className: 'custom-class',
            style: {
                marginTop: '20vh',
            },
        });
    };
    const onFinish = (values) => {
        subFrom(values).then((res) => {
            success(res.msg);
            form.resetFields()
        })
    };
    const lookHandle = (img) => {
        setImg(img.split(','))
        setIsModalOpen(true)
    }
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const chatTypeItemCom = (item, index) => {
        return (
            <div className="chatTypeItem" key={index}>
                <div className="typeName">
                    {item.companyName}
                </div>
                <div className="line"></div>
                <div className="typeAddess">
                    <img src="../assets/ChatUs/address.png" alt="" />{item.companyAddress}
                </div>
                <div className="typePhone">
                    <img src="../assets/ChatUs/phone.png" alt="" />{item.companyPhone}
                </div>
                <div className="payCode">
                    {item.receipt ? <Button ghost type="primary" onClick={() => { lookHandle(item.receipt) }}>付款码查看</Button> : ""}
                </div>

            </div>
        )
    }
    return (
        <div className="aboutUs">
            {contextHolder}
            <div className="banner">
                <img className="bannerPc" src='../assets/ChatUs/chatUsBg.png' alt="" />
                <img className="bannerMob" src='../assets/ChatUs/chatUsBgMob.png' alt="" />
                <div className="bannerContent">
                    <div className="chatCh">联系我们</div>
                    <div className="chatEn">CONTACT US</div>
                    <div className="mail">联系我们邮箱：<a href={`mailto:${'support@sino-bus.com'}`}>support@sino-bus.com</a></div>
                    <div className="mail">联系我们邮箱：<a href={`mailto:${'hr@sino-bus.com(应聘)'}`}>hr@sino-bus.com(应聘)</a></div>
                </div>
            </div>
            <div className="chatType">
                {companyList.map((item, index) => {
                    return chatTypeItemCom(item, index)
                })}
            </div>
            {/* <div className="chatInfo">
                <Form
                    {...layout}
                    name="nest-messages"
                    onFinish={onFinish}
                    style={{ maxWidth: 600 }}
                    validateMessages={validateMessages}
                    form={form}
                >
                    <Form.Item name={['name']} label="姓名/Name" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name={['phono']} label="电话/Phone" rules={[{ type: 'phone', required: true }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item className="email" name={['email']} label="邮箱/Email" rules={[{ type: 'email', required: true }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item className="email" name={['specificNeed']} label="具体需求/Request">
                        <Input.TextArea rows={4} maxLength={6} />
                    </Form.Item>
                    <Form.Item />
                    <div>
                        <Button htmlType="reset" className="reset">重置</Button>
                        <Button htmlType="submit" style={{ background: '#ffd62c', }}>
                            确认
                        </Button>
                    </div>
                </Form>
            </div> */}
            <Modal
                title=""
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isModalOpen}
                footer={null}
                onCancel={handleCancel}
            >
                <div className="pay_img">

                    <p>点击查看更多</p>
                    <Image.PreviewGroup
                        items={isImg}
                    >
                        <Image width={200} src={isImg[0]} alt="" />
                    </Image.PreviewGroup>
                </div>
            </Modal>
            <ChatCom />
        </div >
    )
}
export default AboutUsPage;